/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';

const ITEM_TYPE = 'sortable';

function mapDropConnectToProps(connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
}

function mapDragConnectToProps(connect) {
  return {
    connectDragSource: connect.dragSource()
  };
}

const source = {
  beginDrag(props) {
    return {
      index: props.index
    };
  }
};

const target = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;
    if(dragIndex === hoverIndex) {
      return;
    }
    // find the item we want to displace
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    const clientOffset = monitor.getClientOffset();
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;
    if(dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }
    if(dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }
    props.swapItems(dragIndex, hoverIndex);
    monitor.getItem().index = hoverIndex;
  }
};

class SortableItem extends Component {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    children: PropTypes.element.isRequired,
    swapItems: PropTypes.func.isRequired,
    className: PropTypes.string
  };

  onMouseDown = (e) => {
    e.stopPropagation();
  }

  render() {
    const { connectDragSource, connectDropTarget, className, children } = this.props;
    return connectDropTarget(connectDragSource(
      <div
        className={className}
        onMouseDown={this.onMouseDown}>
        {children}
      </div>
    ));
  }
}

export default DropTarget(ITEM_TYPE, target, mapDropConnectToProps)(DragSource(ITEM_TYPE, source, mapDragConnectToProps)(SortableItem));

